import { toUrlParams } from './toUrlParams';
import { DEFAULT_HSRI, ENDPOINT } from '../ButtonPayment.constants';

export const getUrlBooking = ({
  code,
  environment,
  forwarder: { booking: url = `${process.env.SERVICE_BOOKING}/${ENDPOINT.BOOKING}` } = {},
  id,
  locale,
  reservationCode,
  tracking,
  urlParams: {
    fingerprint,
    gad_source,
    gbraid,
    gclid,
    hsri = DEFAULT_HSRI,
    idchain,
    miraiId,
    type,
    utm_campaign,
    utm_content,
    utm_medium,
    utm_source,
    utm_term,
    variant,
  } = {},
}) => {
  if (!code || !id || !locale || !reservationCode) return;

  return `${url}${toUrlParams({
    code,
    env: environment,
    fingerprint,
    gad_source,
    gbraid,
    gclid,
    hsri,
    idchain,
    idHotel: id,
    lang: locale.split('-')[0],
    miraiId,
    reservationCode,
    tracking,
    type,
    utm_campaign,
    utm_content,
    utm_medium,
    utm_source,
    utm_term,
    variant,
    version: 2,
  })}`;
};
